module.exports = __webpack_public_path__ + "assets/img/head.f6afd41e.png";